const PermissionGroupsList = () =>
  import('@internalDevportal/views/admin/PermissionGroupsList.vue');
const PermissionGroupDetail = () =>
  import('@internalDevportal/views/admin/PermissionGroupDetail.vue');
const Environments = () =>
  import('@internalDevportal/views/admin/environments/EnvironmentList.vue');
const EnvironmentDetail = () =>
  import('@internalDevportal/views/admin/environments/EnvironmentDetail.vue');
const CreateEnvironment = () =>
  import('@internalDevportal/views/admin/environments/CreateEnvironment.vue');
const ProductList = () =>
  import('@internalDevportal/views/products/ProductList.vue');
const ProductsDetail = () =>
  import('@internalDevportal/views/products/ProductDetail.vue');
const PagesDetail = () => import('@internalDevportal/views/PageDetail.vue');
const ApplicationDetail = () =>
  import('@internalDevportal/views/applications/ApplicationDetail.vue');
const ApplicationList = () =>
  import('@internalDevportal/views/applications/ApplicationList.vue');
const SearchDocumentation = () =>
  import('@internalDevportal/views/SearchDocumentation.vue');
const TeamList = () => import('@internalDevportal/views/teams/TeamList.vue');
const TeamDetail = () =>
  import('@internalDevportal/views/teams/TeamDetail.vue');
const TeamDetailMembers = () =>
  import('@internalDevportal/views/teams/TeamDetailMembers.vue');
const TeamPermissionGroupDetailCard = () =>
  import('@internalDevportal/components/Teams/TeamPermissionGroupDetailCard.vue');
const TeamApisCard = () =>
  import('@internalDevportal/components/Teams/TeamApisCard.vue');
const TeamDetailApplications = () =>
  import('@internalDevportal/views/teams/TeamDetailApplications.vue');
const TeamDetailSettings = () =>
  import('@internalDevportal/views/teams/TeamDetailSettings.vue');
const Analytics = () => import('@internalDevportal/views/AnalyticsPage.vue');
const Dashboard = () => import('@internalDevportal/views/DashboardPage.vue');
const AdminPendingApprovals = () =>
  import('@internalDevportal/views/admin/PendingProducts.vue');
const PendingProductDetail = () =>
  import('@internalDevportal/views/admin/PendingProductDetail.vue');
const AdminLogging = () =>
  import('@internalDevportal/views/admin/LoggingPage.vue');
const AdminOverview = () =>
  import('@internalDevportal/views/admin/AdminOverview.vue');

export const internalDevPortalRoutes = [
  {
    path: '',
    redirect: {
      name: 'dashboard',
    },
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminOverview,
    meta: {currentMenu: 0, admin: true, apidex: true},
  },
  {
    path: '/admin/pendingapprovals',
    meta: {currentMenu: 0, admin: true, apidex: true},
    children: [
      {
        path: '',
        name: 'admin_pendingapprovals',
        component: AdminPendingApprovals,
        meta: {currentMenu: 0, admin: true, apidex: true},
      },
      {
        path: ':id',
        name: 'admin_pendingapprovals_detail',
        component: PendingProductDetail,
        meta: {currentMenu: 0, admin: true, apidex: true},
      },
    ],
  },
  {
    path: '/admin/logging',
    name: 'admin_logging',
    component: AdminLogging,
    meta: {currentMenu: 0, admin: true, apidex: true},
  },
  {
    path: '/admin/permissionGroups',
    children: [
      {
        path: '',
        name: 'admin_permissionGroups',
        component: PermissionGroupsList,
        meta: {currentMenu: 0, admin: true, apidex: true},
      },
      {
        path: ':id',
        name: 'admin_permissionGroups_details',
        component: PermissionGroupDetail,
        meta: {currentMenu: 0, admin: true, apidex: true},
      },
      {
        path: ':id/teams',
        name: 'admin_permissionGroups_details_teams',
        component: PermissionGroupDetail,
        meta: {currentMenu: 0, admin: true, apidex: true},
      },
    ],
  },
  {
    path: '/admin/environments',
    meta: {currentMenu: 0, admin: true, apidex: true},
    children: [
      {
        path: '',
        name: 'admin_environments',
        component: Environments,
        meta: {currentMenu: 0, admin: true, apidex: true},
      },
      {
        path: 'create',
        name: 'admin_environments_create',
        component: CreateEnvironment,
        meta: {currentMenu: 0, admin: true, apidex: true},
      },
      {
        path: ':id',
        name: 'admin_environments_details',
        component: EnvironmentDetail,
        meta: {currentMenu: 0, admin: true, apidex: true},
      },
    ],
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {currentMenu: 0, apidex: true},
  },
  {
    path: '/applications',
    meta: {currentMenu: 0, apidex: true},
    children: [
      {
        path: '',
        name: 'apps',
        component: ApplicationList,
        meta: {currentMenu: 0, apidex: true},
      },
      {
        path: ':id',
        name: 'app_details',
        component: ApplicationDetail,
        meta: {currentMenu: 0, apidex: true},
      },
    ],
  },
  {
    path: '/search',
    name: 'search_documentation',
    component: SearchDocumentation,
    props: (route: any) => ({query: route.query.q}),
    meta: {currentMenu: 0, apidex: true},
  },
  {
    path: '/apis',
    meta: {currentMenu: 0, apidex: true},
    children: [
      {
        path: '',
        name: 'products',
        component: ProductList,
        meta: {currentMenu: 0, apidex: true},
      },
      {
        path: ':id',
        name: 'product_details',
        component: ProductsDetail,
        meta: {currentMenu: 0, apidex: true},
      },
    ],
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: Analytics,
    meta: {currentMenu: 0, apidex: true},
  },
  {
    path: '/teams',
    meta: {currentMenu: 0, apidex: true},
    children: [
      {
        path: '',
        name: 'team_list',
        component: TeamList,
        meta: {currentMenu: 0, apidex: true},
      },
      {
        path: ':id',
        component: TeamDetail,
        meta: {currentMenu: 0, apidex: true},
        children: [
          {
            path: '',
            name: 'team_details',
            component: TeamDetailMembers,
            meta: {currentMenu: 0, apidex: true},
          },
          {
            path: 'permissions',
            name: 'team_details_permissions',
            component: TeamPermissionGroupDetailCard,
            meta: {currentMenu: 0, apidex: true, admin: true},
          },
          {
            path: 'apis',
            name: 'team_details_apis',
            component: TeamApisCard,
            meta: {currentMenu: 0, apidex: true},
          },
          {
            path: 'applications',
            name: 'team_details_applications',
            component: TeamDetailApplications,
            meta: {currentMenu: 0, apidex: true},
          },
          {
            path: 'settings',
            name: 'team_details_settings',
            component: TeamDetailSettings,
            meta: {currentMenu: 0, apidex: true},
          },
        ],
      },
    ],
  },
  {
    path: '/pages/:root/:folder?/:route?',
    name: 'pages',
    component: PagesDetail,
    props: (route: {query: {q: any}}) => ({
      query: route.query.q,
    }),
    meta: {currentMenu: 0, apidex: true},
  },
];
